export const trackWebVitals = ({ id, name, value }) => {
  console.log('id: ', id, ', name: ', name, ', value: ', value);
};